export enum WaveformChannelType
{
  LR_SEPERATE,
  MIDDLE,
  LEFT,
  RIGHT,
  MAX_ABSOLUTE,
  EXTREMES
}

export class WaveformGenerationOptions
{
  highestZoomLevel = 10; 
  lowestZoomLevel  = 15;
  type = WaveformChannelType.EXTREMES;
}